import { render, staticRenderFns } from "./businessModal.vue?vue&type=template&id=f2882f4a&scoped=true&"
import script from "./businessModal.vue?vue&type=script&lang=js&"
export * from "./businessModal.vue?vue&type=script&lang=js&"
import style0 from "./businessModal.vue?vue&type=style&index=0&id=f2882f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2882f4a",
  null
  
)

export default component.exports